import EventFooter from '@composites/EventFooter';
import { MODE } from '@utils/constants';
import { useSelector } from 'react-redux';
import { getMode } from '../../store/slices/configSlice';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getUrl } from '@utils/fn';

function Footer() {
  const mode = useSelector(getMode);
  const location = useLocation();
  const { t } = useTranslation();

  const unsubscribePath = `/${getUrl(
    t('mappable-company-routes.newsletter-unsubscribe-url')
  )}`;
  const offerDownloadPath = `/${getUrl(t('offer-download-url'))}`;
  
  if (location.pathname.includes(unsubscribePath)) return null;
  if (location.pathname.includes(offerDownloadPath)) return null;
  if (mode === MODE.OVERVIEW) return null;
  if (mode === MODE.EVENT) return <EventFooter />;

  return null;
}

export default Footer;
